import { useTranslation } from 'react-i18next';
import { Text } from '@lili/lili-frontend-common';
import { Icon, Icons } from '@Components/icon/Icon';

interface MainContentProps {
  onSendSmsClick: () => void;
  openResendOption: boolean;
  timeLeft: string | null;
  smsText: string;
  socureQR?: string;
  isLoading: boolean;
}

export const MainContent = ({
  onSendSmsClick,
  openResendOption,
  smsText,
  timeLeft,
  socureQR,
  isLoading,
}: MainContentProps) => {
  const { t } = useTranslation('nonUsSocure');

  return (
    <>
      {/* Container with left & right halves */}
      <div
        data-testid='main-content-container'
        className='phone:none phone:hidden md:flex relative w-[540px] phone:w-[400px] sm:w-[540px] h-[310px] shadow-lg rounded-[8px] flex'>
        {/* Left side */}
        <div className='w-1/2 flex flex-col items-center justify-center'>
          <Text.H9 className='text-text-main-primary mb-[15px] mt-[8px]'>
            {t('mainContent.scanQrCode')}
          </Text.H9>

          {/* Replace this placeholder with your QR code image/component */}
          <div className='flex max-w-[150px] items-center justify-center'>
            <img src={socureQR} alt='QR code' className='h-[150px] w-[150px]' />
          </div>
        </div>

        {/* Right side */}
        <div className='w-1/2 flex flex-col items-center justify-center '>
          <Text.H9 className='text-text-main-primary whitespace-pre-line text-center'>
            {t('mainContent.sendLinkViaText')}
          </Text.H9>
          <Text.H9 className='text-text-main-primary  whitespace-pre-line text-center'>
            {t('mainContent.message')}
          </Text.H9>

          <button onClick={() => (timeLeft ? null : onSendSmsClick)} className='mt-[20px]  '>
            <div className='flex hover:border hover:border-surface-brand-action-04 flex-col mb-[15px] justify-center items-center w-[158px] h-[144px] pt-[30px] pr-[11.013px] pb-[20px] pl-[9px] gap-[9px] flex-shrink-0 rounded-[14px] border border-surface-primary-bw-03 bg-surface-primary-bw-00'>
              <div className='w-[150px] flex items-center h-[150px] justify-center'>
                {timeLeft && !isLoading && !openResendOption ? (
                  <div className='flex flex-col items-center justify-center'>
                    <Text.H9 id='timeLeft' className='text-text-main-primary'>
                      Send again:
                    </Text.H9>
                    <Text.H9 id='timeLeft' className='text-text-main-primary'>
                      {timeLeft} seconds
                    </Text.H9>
                  </div>
                ) : (
                  <button
                    onClick={onSendSmsClick}
                    className='flex items-center justify-center flex-col'>
                    <Icon icon={Icons.TextMessage} className='pb-[5px]' />
                    {openResendOption && (
                      <Text.H9 className='text-text-main-primary'>
                        {t('mainContent.didntGetIt')}
                      </Text.H9>
                    )}
                    <Text.H10 className='text-text-brand-primary'>{smsText}</Text.H10>
                  </button>
                )}
              </div>
            </div>
          </button>
        </div>

        {/* Absolutely-positioned vertical divider + "OR" text */}
        <div className='absolute top-4 bottom-4 left-1/2 -translate-x-1/2 w-[1px] bg-outline-primary-bw-03'>
          <span className='absolute text-text-main-primary font-metricSemibold top-[13.66%] left-1/2 -translate-x-1/2 -translate-y-1/2 bg-surface-primary-bw-00 px-2'>
            {t('mainContent.orDivider')}
          </span>
        </div>
      </div>
    </>
  );
};
